import { useNavigate } from '@tanstack/react-router';

import { useOpenRoutine } from '@/features/routines/hooks/use-open-routine';
import { isNewTabClick, useTabs } from '@/features/tabs';
import type { SupportedEntityReference } from '@/utils/entity-reference';

import { EntityReferenceChip } from './EntityReferenceChip';

export const EntityReferenceLink = ({
  reference,
}: {
  reference: SupportedEntityReference;
}) => {
  const { openRoutine } = useOpenRoutine();
  const navigate = useNavigate();
  const { openTab } = useTabs();
  const { entity, attributes } = reference;
  const id = attributes.id;
  const path = `/${entity}s/${id}`;

  return (
    <a
      href={path}
      className="inline-flex max-w-full cursor-default rounded-full align-top outline-none focus-visible:ring-2 focus-visible:ring-ring"
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();

        switch (entity) {
          case 'routine':
            openRoutine(Number(id), event);
            break;
          case 'chat':
          case 'meeting':
            if (isNewTabClick(event)) {
              openTab({ path });
            } else {
              navigate({ to: path });
            }
            break;
        }
      }}
    >
      <EntityReferenceChip reference={reference} />
    </a>
  );
};
